var global = window
let tooltipHide = null;
let visibilityCheckInterval = null;
let currentTooltipTarget = null;

function isElementVisible(el) {
    if (!el || !el.length) return false;
    const domEl = el[0];
    if (!domEl || !document.body.contains(domEl)) return false;
    if (!el.is(':visible')) return false;
    if (el.css('visibility') === 'hidden' || el.css('opacity') === '0') return false;
    return true;
}

function startVisibilityWatcher(el) {
    stopVisibilityWatcher();
    currentTooltipTarget = el;
    visibilityCheckInterval = setInterval(function() {
        if (!currentTooltipTarget || !isElementVisible(currentTooltipTarget)) {
            global.hideTooltip(true);
        }
    }, 150);
}

function stopVisibilityWatcher() {
    if (visibilityCheckInterval) {
        clearInterval(visibilityCheckInterval);
        visibilityCheckInterval = null;
    }
    currentTooltipTarget = null;
}

global.hideTooltip = function(immediate) {
    if (tooltipHide) {
        clearTimeout(tooltipHide);
        tooltipHide = null;
    }
    stopVisibilityWatcher();
    $('.tooltiped').removeClass('tooltiped');
    const tooltip = $('.protip-containers .protip-container');
    if (immediate) {
        tooltip.removeClass('visible').addClass('hidden');
    } else {
        tooltipHide = setTimeout(function() {
            $('.tooltiped').removeClass('tooltiped');
            tooltip.removeClass('visible');
            tooltipHide = setTimeout(function() {
                tooltip.addClass('hidden');
            }, 250);
        }, 10);
    }
};

global.positionTooltip = function(el, tooltip, requestedPosition) {
    if (!el || !el.length || !isElementVisible(el)) {
        global.hideTooltip(true);
        return;
    }
    const tooltipArrow = tooltip.find('.protip-arrow');
    const elOffset = el.offset();
    if (!elOffset) return;
    const elWidth = el.outerWidth() || 0;
    const elHeight = el.outerHeight() || 0;
    const tipWidth = tooltip.outerWidth() || 0;
    const tipHeight = tooltip.outerHeight() || 0;

    const winWidth = $(window).width();
    const winHeight = $(window).height();
    const scrollTop = $(window).scrollTop();
    const scrollLeft = $(window).scrollLeft();

    const elViewportTop = elOffset.top - scrollTop;
    const elViewportBottom = winHeight - (elViewportTop + elHeight);
    const elCenterLeft = elOffset.left + (elWidth / 2);

    const margin = 10;
    const offsetDistance = 12;

    // Décision de la position verticale (top par défaut, ou flip vers bottom si pas assez d'espace au-dessus)
    let actualPosition = requestedPosition || 'top';
    if (actualPosition === 'top' && (elViewportTop - tipHeight - offsetDistance < margin) && elViewportBottom > elViewportTop) {
        actualPosition = 'bottom';
    } else if (actualPosition === 'bottom' && (elViewportBottom - tipHeight - offsetDistance < margin) && elViewportTop > elViewportBottom) {
        actualPosition = 'top';
    }

    // Calcul du Y
    let topPos;
    if (actualPosition === 'bottom') {
        topPos = elOffset.top + elHeight + offsetDistance;
        tooltip.css('transform', 'translateX(-50%) translateY(0)');
    } else {
        topPos = elOffset.top - offsetDistance;
        tooltip.css('transform', 'translateX(-50%) translateY(-100%)');
    }

    // Calcul du X avec clamp pour éviter que le tooltip ne déborde à gauche ou à droite de l'écran
    const minCenterX = scrollLeft + (tipWidth / 2) + margin;
    const maxCenterX = scrollLeft + winWidth - (tipWidth / 2) - margin;
    const clampedCenterX = Math.max(minCenterX, Math.min(elCenterLeft, maxCenterX));
    const leftShift = clampedCenterX - elCenterLeft;

    tooltip.css({
        left: clampedCenterX + 'px',
        top: topPos + 'px'
    });

    // Mettre à jour l'orientation et centrer la flèche précisément sur l'élément déclencheur
    tooltip.attr('data-pt-position', actualPosition);
    if (tooltipArrow.length) {
        const arrowLeftPercent = 50 - ((leftShift / (tipWidth || 1)) * 100);
        const clampedArrowPercent = Math.max(10, Math.min(arrowLeftPercent, 90));
        tooltipArrow.css({
            left: clampedArrowPercent + '%',
            right: 'auto',
            marginLeft: '-8px'
        });
    }
};

global.updateTooltip = function(target, newTitle) {
    if (newTitle === undefined || newTitle === null) return;
    const $elements = $(target);
    if (!$elements.length) return;

    $elements.each(function() {
        const $el = $(this);
        $el.attr('data-tip-title', newTitle);
        $el.data('tip-title', newTitle);

        if ($el.hasClass('protip')) {
            $el.removeAttr('title');
        } else {
            $el.attr('title', newTitle);
        }

        if ($el.hasClass('tooltiped')) {
            if (!isElementVisible($el)) {
                global.hideTooltip(true);
                return;
            }
            const $tooltip = $('.protip-containers .protip-container');
            if ($tooltip.length && $tooltip.hasClass('visible')) {
                $tooltip.find('.protip-content').html(newTitle);
                if (typeof global.positionTooltip === 'function') {
                    global.positionTooltip($el, $tooltip, $el.data('tip-position') || 'top');
                }
            }
        }
    });
};

global.initTooltips = function(targetSelector) {
    $(targetSelector).find('[title]:not(.protip)').each(function() {
        let rawTitle = $(this).attr('title');
        if (rawTitle) {
            // Sécurité anti-duplication : si le titre contient deux moitiés identiques séparées par un espace
            if (rawTitle.length > 3) {
                const halfLen = Math.floor(rawTitle.length / 2);
                if (rawTitle.length % 2 === 1 && rawTitle.charAt(halfLen) === ' ') {
                    const first = rawTitle.substring(0, halfLen);
                    const second = rawTitle.substring(halfLen + 1);
                    if (first === second) {
                        rawTitle = first;
                        $(this).attr('title', rawTitle);
                    }
                }
            }

            let protipItems = $(this).attr('data-tip-title', rawTitle).not('.protip').not('iframe');

            protipItems.mouseenter(function(event) {
                event.stopPropagation();
                if (tooltipHide) {
                    clearTimeout(tooltipHide);
                    tooltipHide = null;
                }
                const el = $(this);
                if (!isElementVisible(el)) {
                    return;
                }
                let container = $('body > .protip-containers');
                if (!container.length) {
                    container = $('<div class="protip-containers"></div>')
                    $('body').append(container);
                    container.append('<div class="protip-container" style="max-width: 600px; min-width: 184px; transform: translateX(-50%) translateY(-100%);" data-pt-position="top"><span class="protip-arrow"></span><i class="fa"></i><div class="protip-content"></div></div>');
                }
                const icon = el.data('tip-icon');
                const title = el.data('tip-title');
                const scheme = el.data('tip-scheme') || 'default';
                const requestedPosition = el.data('tip-position') || 'top';

                const tooltip = $('.protip-containers .protip-container');
                const tooltipIcon = tooltip.find('.fa');

                tooltip.attr('class', 'visible protip-container protip-skin-default protip-skin-default--size-normal protip-skin-default--scheme-' + scheme + ' protip-show');
                tooltip.find('.protip-content').html(title);
                tooltip.data('str', el.get(0).toString());

                if (icon) {
                    tooltipIcon.show().attr('class', 'fa ' + icon);
                } else {
                    tooltipIcon.hide();
                }

                $('.tooltiped').removeClass('tooltiped');
                el.addClass('tooltiped');

                global.positionTooltip(el, tooltip, requestedPosition);
                startVisibilityWatcher(el);
            });

            protipItems.mouseleave(function(event) {
                event.stopPropagation();
                global.hideTooltip(false);
            });

            protipItems.on('click', function() {
                const el = $(this);
                setTimeout(function() {
                    if (!isElementVisible(el)) {
                        global.hideTooltip(true);
                    }
                }, 0);
            });

            protipItems.addClass('protip');
            $(this).removeAttr('title')
        }
    });

    /*
    $.protip({
        "selector":           '.protip',
        "namespace":          'tip',
        "observer":           false,
        "delayResize":        100,
        "iconTemplate":     '<i class="fa {icon}"></i>',
        "defaults":           {
            "position": 'top',
            "offset-top": 20,
            "scheme": 'default'
        }
    });
    */
}

global.removeTooltips = function(targetSelector) {
    if (targetSelector) {
        const $target = $(targetSelector);
        if ($target.hasClass('tooltiped') || $target.find('.tooltiped').length) {
            global.hideTooltip(true);
        }
    }
    $(targetSelector).find('.protip').each(function() {
        $('[data-pt-identifier='+$(this).data('tipIdentifier')+']').remove();
    })
}
